class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.detailsElement = this.querySelector('details');
    this.contentElement = this.querySelector('.mega-menu__content'); 

    // Bind event handlers
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleClick = this.handleClick.bind(this);

    // Add event listeners for the details element
    this.detailsElement.addEventListener('mouseenter', this.handleMouseEnter);
    this.detailsElement.addEventListener('mouseleave', this.handleMouseLeave);
    this.detailsElement.querySelector('summary').addEventListener('click', this.handleClick);

    // Add event listeners for the content element
    if (this.contentElement) {
      this.contentElement.addEventListener('mouseenter', this.handleMouseEnter);
      this.contentElement.addEventListener('mouseleave', this.handleMouseLeave);
    }
  }

  handleMouseEnter() {
    console.log('Mouse ENTER');
    // Open the details element on hover
    this.detailsElement.setAttribute('open', '');
    this.detailsElement.querySelector('summary').setAttribute('aria-expanded', 'true');
  }

  handleMouseLeave(event) {
    const relatedTarget = event.relatedTarget;
    console.log('Mouse Leave', relatedTarget);

    // Check if the mouse is entering the content or details elements
    if (!this.contentElement.contains(relatedTarget) && !this.detailsElement.contains(relatedTarget)) {
      // If the mouse is not over the content or details, close the menu
      this.closeMenu();
    }
  }

  closeMenu() {
    console.log('---- closeMenu -----');
    this.detailsElement.removeAttribute('open'); 
    this.detailsElement.querySelector('summary').setAttribute('aria-expanded', 'false');
  }

  handleClick(event) {
    event.preventDefault();
    // Navigate to the URL specified in the summary element as the data-url attribute
    const url = this.detailsElement.querySelector('summary').getAttribute('data-url');
    if (url) {
      this.closeMenu();
      window.location.href = url;
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
